/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// Services
import Person from 'services/data/person';

// Components
import SVG from 'components/widgets/icons/svg';


export default class AddToContactForm extends React.Component {
  static propTypes = {
    triageItem: PropTypes.shape({
      setOpen: PropTypes.func
    })
  };

  render() {
    const { triageItem } = this.props;

    return (
      <div className="triage-add-to-contact-form">
        <div className="triage-option-form-header triage-option-header" onClick={() => triageItem.setOpen(false)}>
          <SVG src="svg/add-contact.svg" className="add-contact triage-option-icon" />
          <span>Add to Contact</span>
          <SVG src="svg/close.svg" className="close-triage-submenu" />
        </div>
        <div className="triage-option-submenu">
          Feature coming in future release!
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/forms/add-to-contact.js